import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { TabType } from '../types';

export const DEFAULT_TAB = TabType.PROFILE;

// Tabs that exist in the enum but have no built UI yet — never offered.
const HIDDEN_TABS: TabType[] = [];

/**
 * @param gatedTabs Tabs hidden for this person by a feature flag. Same handling
 * as the unbuilt ones: not offered, and a URL pointing at one falls back to the
 * default tab.
 */
export const useActiveTab = (gatedTabs: TabType[] = []) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get('tab') as TabType;

  // Initialize tab if not set — use replace to avoid polluting browser history
  useEffect(() => {
    if (!currentTab) {
      setSearchParams({ tab: DEFAULT_TAB }, { replace: true });
    }
  }, [currentTab, setSearchParams]);

  const hiddenTabs = [...HIDDEN_TABS, ...gatedTabs];

  const availableTabs = Object.values(TabType).filter(
    (tab) => !hiddenTabs.includes(tab)
  );

  const setActiveTab = (tab: TabType) => {
    if (availableTabs.includes(tab)) {
      setSearchParams({ tab });
    }
  };

  return {
    // Fall back to the default tab when the URL points at a hidden/unknown tab
    // (e.g. ?tab=TEAM) so the form always renders real content.
    activeTab: availableTabs.includes(currentTab) ? currentTab : DEFAULT_TAB,
    setActiveTab,
    availableTabs,
  };
};
